import { useTranslation } from 'react-i18next';
import { ShieldOff } from 'lucide-react';
import { Card } from './Card';
import { EmptyState } from './Feedback';

/** Permission-denied state with the reason category (design system §5.7) — never a blank page. */
export function AccessDenied({ reason }: { reason?: string }) {
  const { t } = useTranslation('common');
  return (
    <Card>
      <EmptyState icon={ShieldOff} title={t('errors.forbidden.title')} description={reason ?? t('errors.forbidden.body')} />
    </Card>
  );
}
